/** Max gap between loader unmount/remount to preserve slide index (route → page handoff). */
export const CAROUSEL_SESSION_HANDOFF_MS = 2500;

export const carouselSession = {
  messageIndex: 0,
  imageIndex: 0,
  slideShownAt: 0,
  lastUnmountAt: 0,
};

export function shouldRestoreCarouselSession() {
  if (!carouselSession.lastUnmountAt) return false;
  return Date.now() - carouselSession.lastUnmountAt <= CAROUSEL_SESSION_HANDOFF_MS;
}

/** Called on unmount — keeps slideShownAt so remount can subtract elapsed time. */
export function persistCarouselSession(messageIndex, imageIndex) {
  carouselSession.messageIndex = messageIndex;
  carouselSession.imageIndex = imageIndex;
  carouselSession.lastUnmountAt = Date.now();
}

export function markCarouselSlideShown(messageIndex, imageIndex) {
  carouselSession.messageIndex = messageIndex;
  carouselSession.imageIndex = imageIndex;
  carouselSession.slideShownAt = Date.now();
}

export function getElapsedOnCurrentSlide() {
  if (!carouselSession.slideShownAt) return 0;
  return Date.now() - carouselSession.slideShownAt;
}

export function getRestoredMessageIndex(messageCount) {
  if (messageCount <= 1 || !shouldRestoreCarouselSession()) {
    return 0;
  }
  return Math.min(carouselSession.messageIndex, messageCount - 1);
}

export function getRestoredImageIndex(imageCount) {
  if (imageCount <= 1 || !shouldRestoreCarouselSession()) {
    return 0;
  }
  return Math.min(carouselSession.imageIndex, imageCount - 1);
}
